/*eslint-disable */
import {bus} from '@/main';
export default {
  name: 'access-features-of-package-popup',
  components: {},
  props: [],
  data () {
    return {
    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {
    blurbTextPopupClosed(){
      bus.$emit('accessFeaturesOfPackageStateBus', false);
      document.body.classList.remove('body_right_scroll_remove')
    }
  }
}